if (!customElements.get('student-testimonials')) {
  class StudentTestimonials extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    get swiperContainer() {
      return this.querySelector('.students-testimonials__card');
    }

    get paginationEl() {
      return this.querySelector('.swiper-pagination');
    }

    get prevButtonEl() {
      return this.querySelector('.swiper-button-prev');
    }

    get nextButtonEl() {
      return this.querySelector('.swiper-button-next');
    }

    getConfig() {
      return {
        slidesPerView: 1,
        slidesOffsetAfter: 0,
        slidesOffsetBefore: 0,
        spaceBetween: 12,
        centeredSlides: false,
        grabCursor: true,
        pagination: {
          el: this.paginationEl,
          type: 'fraction',
        },
        keyboard: {
          enabled: true,
        },
        breakpoints: {
          767: {
            slidesPerView: 1.3,
            slidesPerGroup: 1,
            spaceBetween: 20,
            slidesOffsetAfter: 20,
            slidesOffsetBefore: 20,
          },
          1025: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 12,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
          },
        },
        navigation: {
          nextEl: this.nextButtonEl,
          prevEl: this.prevButtonEl,
        },
      };
    }

    init() {
      if (this.swiperContainer) {
        this.swiper = new Swiper(this.swiperContainer, this.getConfig());
      }
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
    }
  }

  customElements.define('student-testimonials', StudentTestimonials);
}
